export default __webpack_public_path__ + "assets/images/3f30b7dfb5b8f947ac63997199c2ec3c.svg";